<app-carousel [typeSearch]="'Employee'"></app-carousel>
<div class="body-app mt-3 mb-3">
  <div class="content-app">
    <div class="row mt-5 mb-4">
      <div class="col-md-6 col-sm-6 col-12">
        <h3 class="section-title">
          <i class="fa-solid fa-briefcase me-2 text-primary"></i>
          Ofertas laborales
        </h3>
      </div>
      <div class="col-md-6 col-sm-6 col-12">
        <div class="text-end">
          <button
            type="button"
            class="btn btn-primary rounded-pill"
            routerLink="/companies/create-job-offer"
          >
            <i class="fa-regular fa-square-plus me-1"></i>
            Nueva oferta
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="isLoading" class="text-center mb-3">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div
      class="card rounded-4 mb-3 border-0"
      *ngIf="!isLoading && items.length > 0"
    >
      <div class="card-body p-0">
        <ul
          class="list-group"
          [ngClass]="{ 'list-container-scroll': items.length > 5 }"
        >
          <li
            class="list-group-item list-group-item-job"
            *ngFor="let item of items"
          >
            <div class="row">
              <div
                class="col-xl-2 col-lg-2 col-md-2 col-sm-3 col-4"
                [routerLink]="['/home/job', item.id]"
                style="cursor: pointer"
              >
                @if(item.logoUrl){
                <img
                  [src]="item.logoUrl"
                  onerror="this.error=null; this.src='assets/Images/logo-compania.jpg'"
                  alt="Logo"
                  class="logo-company"
                />
                }@else{
                <img
                  src="assets/Images/logo-compania.jpg"
                  alt="Logo"
                  class="logo-company"
                />
                }
              </div>
              <div class="col-xl-6 col-lg-6 col-md-10 col-sm-9 col-8">
                <div class="d-flex align-items-center mb-1">
                  <a
                    [routerLink]="['/home/job', item.id]"
                    class="text-decoration-none fs-5 mt-0 mb-0 fw-bold d-block"
                  >
                    {{ item.title }}
                  </a>
                </div>
                <div class="d-flex align-items-center mb-2">
                  <i class="fa-regular fa-building text-primary me-1"></i>
                  <span class="text-muted">{{ item.ownerFullName }}</span>
                </div>
                <p class="mt-0 mb-3 text-secondary">
                  {{ item.description }}
                </p>
                <div class="row mb-3">
                  <div class="col-md-4 col-sm-6 col-12 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="icon-bg me-2">
                        <i class="fa-regular fa-clock text-primary"></i>
                      </div>
                      <div>
                        <label class="fw-bold d-block mb-0 small text-secondary"
                          >Tipo de Contrato</label
                        >
                        <span>{{
                          item.contractTypeName || "No especificado"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-12 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="icon-bg me-2">
                        <i class="fa-solid fa-hourglass-half text-primary"></i>
                      </div>
                      <div>
                        <label class="fw-bold d-block mb-0 small text-secondary"
                          >Duración del Contrato</label
                        >
                        <span>{{
                          item.contractDurationName || "No especificado"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-12 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="icon-bg me-2">
                        <i class="fa-regular fa-calendar text-primary"></i>
                      </div>
                      <div>
                        <label class="fw-bold d-block mb-0 small text-secondary"
                          >Fecha de Publicación</label
                        >
                        <span>{{
                          item.publicOn
                            ? (item.publicOn | date : "dd/MM/yyyy")
                            : "No especificado"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-12 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="icon-bg me-2">
                        <i
                          class="fa-regular fa-calendar-xmark text-primary"
                        ></i>
                      </div>
                      <div>
                        <label class="fw-bold d-block mb-0 small text-secondary"
                          >Fecha de Cierre</label
                        >
                        <span>{{
                          item.closeOn
                            ? (item.closeOn | date : "dd/MM/yyyy")
                            : "No especificado"
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-6 col-12 mb-2">
                    <div class="d-flex align-items-center">
                      <div class="icon-bg me-2">
                        <i class="fa-solid fa-location-dot text-primary"></i>
                      </div>
                      <div>
                        <label class="fw-bold d-block mb-0 small text-secondary"
                          >Ubicación</label
                        >
                        <span>{{ item.countryName || "No especificado" }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                <app-job-offer-card
                  [offer]="item"
                  *ngIf="item.isEnabled; else deletedJob"
                ></app-job-offer-card>
                <ng-template #deletedJob>
                  <div
                    class="alert alert-danger rounded-4 shadow-sm"
                    role="alert"
                  >
                    <i class="fa-solid fa-triangle-exclamation me-2"></i>
                    Oferta laboral eliminada
                  </div>
                </ng-template>
                <div
                  class="d-flex justify-content-between align-items-center mt-3"
                >
                  <!-- Botones de acción -->
                  <div class="btn-action-group">
                    <button
                      type="button"
                      class="btn btn-outline-primary"
                      [routerLink]="[
                        '/companies/create-job-offer',
                        viewEnums.Edit,
                        item.id
                      ]"
                      *ngIf="item.isEnabled"
                    >
                      <i class="fa-solid fa-pen-to-square me-1"></i>
                      Editar
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      title="Compartir"
                      data-bs-toggle="modal"
                      data-bs-target="#modalCompartirOfertaIn"
                      *ngIf="item.isEnabled"
                      (click)="openShareModal(item)"
                    >
                      <i class="fa-solid fa-share-from-square"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-success"
                      title="Previsualizar"
                      [routerLink]="['/companies/job-offer-details', item.id]"
                    >
                      <i class="fa-solid fa-eye"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      (click)="deleteJob(item.id)"
                      *ngIf="item.isEnabled"
                    >
                      <i class="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="!isLoading && items.length > 0" class="mt-4 mb-3 text-center">
      <app-pagination
        [page]="page"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      >
      </app-pagination>
    </div>
    <div
      *ngIf="!isLoading && items.length === 0"
      class="alert alert-info text-center rounded-4 shadow-sm mt-4"
    >
      <i class="fa-solid fa-info-circle me-2"></i> No hay ofertas laborales para
      mostrar
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modalCompartirOfertaIn"
  tabindex="-1"
  aria-labelledby="modalCompartirLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalCompartirLabel">Compartir</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p class="text-left">
          Seleccione el medio por el cual desea compartir el link:
        </p>
        <div class="row">
          <div class="col-6 text-center">
            <a
              [href]="
                'mailto:?subject=Revisa esta oferta de trabajo&body=' +
                selectedJobUrl
              "
              target="_blank"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="Correo electrónico"
            >
              <i class="fa-regular fa-envelope fa-3x"></i>
              Correo electrónico
            </a>
          </div>
          <div class="col-6 text-center">
            <a
              [href]="
                'https://www.facebook.com/sharer/sharer.php?u=' + selectedJobUrl
              "
              target="_blank"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="Facebook"
            >
              <i class="fa-brands fa-facebook fa-3x"></i>
              Facebook
            </a>
          </div>
          <div class="col-6 text-center">
            <a
              href="javascript:void(0);"
              (click)="copyToClipboard()"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="Instagram"
            >
              <i class="fa-brands fa-instagram fa-3x"></i>
              Instagram
            </a>
          </div>
          <div class="col-6 text-center">
            <a
              [href]="
                'https://twitter.com/intent/tweet?text=Mira esta oferta de trabajo: ' +
                selectedJobUrl
              "
              target="_blank"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="X"
            >
              <i class="fa-brands fa-x-twitter fa-3x"></i>
              X
            </a>
          </div>
          <div class="col-6 text-center">
            <a
              [href]="'https://wa.me/?text=' + selectedJobUrl"
              target="_blank"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="Whatsapp"
            >
              <i class="fa-brands fa-whatsapp fa-3x"></i>
              Whatsapp
            </a>
          </div>
          <div class="col-6 text-center">
            <a
              [href]="
                'https://t.me/share/url?url=' +
                selectedJobUrl +
                '&text=Te comparto esta oferta de empleo'
              "
              target="_blank"
              class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
              title="Telegram"
            >
              <i class="fa-brands fa-telegram fa-3x"></i>
              Telegram
            </a>
          </div>
          <div class="col-12 text-center">
            <button
              class="btn btn-outline-dark mt-2"
              (click)="copyToClipboard()"
            >
              <i class="fa-regular fa-copy"></i> Copiar enlace
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
